/* eslint-disable react/display-name, react/prop-types */
import React, {createElement} from 'react';
import {Route, Switch} from 'react-router-dom';
import Bacon from 'Bacon';
import LegacyPage from 'components/LegacyPage';

function scriptsToBaconStream(pathArray) {
    return Bacon.fromCallback(function (callback) {
        switch (pathArray.join(' ')) {
            case 'recordings':
                require(['recordings'], convertScriptsToArray.bind(null, callback));
                break;
            case 'ohjelmaopas/programlist':
                require(['ohjelmaopas/programlist'], convertScriptsToArray.bind(null, callback));
                break;
            default:
                console.trace('No binding set for', pathArray);
                callback([]);
        }
    });
}

function convertScriptsToArray(callback) {
    const args = [].slice.call(arguments);
    args.shift();
    return callback(args);
}

const fromArray = callback => args => callback.apply(null, args);

const renderLegacy = (page, loadTemplate, leave) =>
    ({match}) => createElement(LegacyPage, {page, loadTemplate, leave, match});

const ifPageChanged = fn => request => request.pageChange ? fn(request) : undefined;

const ohjelmaopasTemplates = ifPageChanged(({render}) => {
    return scriptsToBaconStream(["ohjelmaopas/programlist"]).flatMap(fromArray(programList => {
        const programs = programList.info.doAction(v => console.log('programList.info', v));
        return render("ohjelmaopas", {
            days: programs.map(".days"),
            epgListView: programs.map(".epgListView"),
            channels: programs.map(".channels"),
            rows: programs.map(".rows"),
            partitionedChannels: programs.map(".partitionedChannels")
        }, ["ohjelmaopas-channelslist-partial", "ohjelmaopas-content-partial", "ohjelmaopas-content-program-partial", "ohjelmaopas-toolbar-partial"]);
    }));
});

const tallennesaannotTemplates = ifPageChanged(({render}) =>
    scriptsToBaconStream(["recordings"]).flatMap(fromArray(recordings => {
        const rules = recordings.getWildcards({
            sortBy: "startTime",
            sortOrder: "desc"
        });

        return render("recording-rules", {
            rules: rules.map(".rules"),
            disabledRules: rules.map(".disabledRules"),
            folder: rules.map(".folder"),
            folderlist: rules.map(".folderlist"),
            channels: rules.map(".channels"),
            quota: rules.map(".quota")
        }, ["recordings-sidebar-partial",
            "recording-rules-content-partial",
            "recording-rules-edit-partial",
            "recording-rules-list-partial",
            "folders-partial",
            "recordings-quota-partial",
            "recordings-marketing-text-partial",
            "popular-recordings-partial"
        ]);
    }))
);

const onHakuRender = ifPageChanged(() => document.location.reload());

const flatten = routes => {
    const routeArray = [];
    for (const route of routes) {
        if (Array.isArray(route)) {
            for (const r of route) {
                routeArray.push(r);
            }
        } else {
            routeArray.push(route);
        }
    }
    return routeArray;
};

/**
 * react-router unmounts routes between changes that have different keys, and we don't want that
 * because the side effects of LegacyPages need to be executed in a specific order.
 *
 * This creates a Switch-component with keyless routes as children.
 */
const legacyRoutes = routes => {
    // Can't just do <Switch>{routes}</Switch>, since array children must have a unique
    // key for all items. Calling createElement with children as vararg avoids needing keys.
    const args = [Switch, null].concat(flatten(routes));
    return React.createElement.apply(React, args);
};

export default legacyRoutes([

    <Route exact path='/haku/:type?' render={renderLegacy('haku', onHakuRender)}/>,
    <Route exact path='/ohjelmaopas/omatkanavat' render={renderLegacy('omatkanavat')}/>,
    <Route exact path='/ohjelmaopas/:date?' render={renderLegacy('ohjelmaopas', ohjelmaopasTemplates)}/>,
    <Route exact path='/ohjelmaopas/ohjelma/:programId' render={renderLegacy('ohjelma')}/>,

    [
        "/tallenteet",
        "/tallenteet/kansio/:id",
        "/tallenteet/sivu/:page",
        "/tallenteet/kansio/:id/sivu/:page"
    ].map(path => <Route exact path={path}
                         render={renderLegacy('tallenteet', () => undefined)}/>),

    <Route exact path='/tallenteet/tulevat'
           render={renderLegacy('tulevattallenteet')}/>,

    <Route exact path='/tallenteet/duplikaatit'
        render={renderLegacy('duplikaatit')}/>,

    <Route exact path='/tallenteet/jatka-katsomista'
        render={renderLegacy('jatkakatsomista')}/>,

    <Route exact path='/tallenteet/poistuvat/sivu/:page'
        render={renderLegacy('poistuvattallenteet')}/>,

    <Route exact path='/tallenteet/roskakori/sivu/:page' render={renderLegacy('roskakori')}/>,

    <Route exact path='/tallenteet/saannot'
           render={renderLegacy('tallennesaannot', tallennesaannotTemplates)}/>,

    <Route exact path='/salasana' render={renderLegacy('salasana')}/>,
]);





// WEBPACK FOOTER //
// ./web/js/legacy-routes.js